import { useState } from 'react';
import Validator from 'validatorjs';
import React, { useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import PaisesOptions from '../../support/catalogos/pagosaextranjeros/PaisesOptions';
import ConceptoPagoOptions from '../../support/catalogos/pagosaextranjeros/ConceptoPagoOptions';
import EsBenefEfectDelCobroOptions from '../../support/catalogos/pagosaextranjeros/EsBenefEfectDelCobroOptions';
import ComplementoPagosaextranjerosRules from '../../support/rules/complementos/ComplementoPagosaextranjerosRules';

const rulesCallback = ComplementoPagosaextranjerosRules;

const ComplementoPagosaextranjeros = (props) => {
  const [data, setData] = useState(props.data || {});

  const [validation, setValidation] = useState({
    validator: new Validator({}, rulesCallback()),
    isValid: false,
  });

  const rules = rulesCallback(data.EsBenefEfectDelCobro);
  const { isValid } = validation;
  const { Beneficiario = {} } = data;
  const { NoBeneficiario = {} } = data;

  const handleOnChange = (value) => {
    const newData = {
      ...data,
      ...value,
    };

    setData(newData);
  };

  const handleOnBeneficiarioChange = (value) => {
    const { Beneficiario = {} } = data;

    const newData = {
      ...data,
      Version: '1.0',
      NoBeneficiario: undefined,
      Beneficiario: {
        ...Beneficiario,
        ...value,
      },
    };

    setData(newData);
  };

  const handleOnNoBeneficiarioChange = (value) => {
    const { NoBeneficiario = {} } = data;

    const newData = {
      ...data,
      Version: '1.0',
      Beneficiario: undefined,
      NoBeneficiario: {
        ...NoBeneficiario,
        ...value,
      },
    };

    setData(newData);
  };

  const validate = (data) => {
    const validator = new Validator(data, rules);

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidation(newValidator);
  };

  const handleOnComplementoAdd = () => {
    const Pagosaextranjeros = data;

    props.onChange({ Pagosaextranjeros });

    clearData();
  };

  useEffect(() => validate(data), [data]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOutForm = () => {
    props.onCancel();
  };

  const clearData = () => {
    setData({});
  };

  return (
    <div className="pb-4">
      <div>
          <strong className="text-black text-upper">Pagos a Extranjeros</strong>
      </div>
      <div className="section">
        <Form autoComplete="off">
          <Row>
            <Col sm md={4}>
              <FormControl
                type="select"
                label="Emisor es beneficiario del cobro?"
                name="EsBenefEfectDelCobro"
                placeholder=""
                help=""
                options={EsBenefEfectDelCobroOptions}
                rules={rules.EsBenefEfectDelCobro}
                value={data.EsBenefEfectDelCobro}
                onChange={handleOnChange}
              />
            </Col>
          </Row>

          {data.EsBenefEfectDelCobro === 'SI' && (
            <>
              <Row>
                <Col>
                  <div>
                    <strong className="text-muted">
                      Beneficiario
                    </strong>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm md={3}>
                  <FormControl
                    type="text"
                    label="RFC"
                    name="RFC"
                    placeholder=""
                    help=""
                    minLength="12"
                    maxLength="13"
                    rules={rules.Beneficiario.RFC}
                    value={Beneficiario.RFC}
                    onChange={handleOnBeneficiarioChange}
                  />
                </Col>
                <Col sm md={3}>
                  <FormControl
                    type="text"
                    label="CURP"
                    name="CURP"
                    placeholder=""
                    help=""
                    minLength="18"
                    maxLength="18"
                    rules={rules.Beneficiario.CURP}
                    value={Beneficiario.CURP}
                    onChange={handleOnBeneficiarioChange}
                  />
                </Col>
                <Col sm md={3}>
                  <FormControl
                    type="text"
                    label="Razón social"
                    name="NomDenRazSocB"
                    placeholder=""
                    help=""
                    rules={rules.Beneficiario.NomDenRazSocB}
                    value={Beneficiario.NomDenRazSocB}
                    onChange={handleOnBeneficiarioChange}
                  />
                </Col>
                <Col sm md={3}>
                  <FormControl
                    type="select"
                    label="Concepto Pago"
                    name="ConceptoPago"
                    placeholder=""
                    help=""
                    rules={rules.Beneficiario.ConceptoPago}
                    options={ConceptoPagoOptions}
                    value={Beneficiario.ConceptoPago}
                    onChange={handleOnBeneficiarioChange}
                  />
                </Col>
                <Col sm md={12}>
                  <FormControl
                    as="textarea"
                    label="Descripción Concepto"
                    name="DescripcionConcepto"
                    placeholder=""
                    help=""
                    minLength="1"
                    maxLength="256"
                    rules={
                      rules.Beneficiario.DescripcionConcepto
                    }
                    value={Beneficiario.DescripcionConcepto}
                    onChange={handleOnBeneficiarioChange}
                  />
                </Col>
              </Row>
            </>
          )}

          {data.EsBenefEfectDelCobro === 'NO' && (
            <>
              <Row>
                <Col>
                  <div>
                    <strong className="text-muted">
                      No Beneficiario
                    </strong>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm md={3}>
                  <FormControl
                    type="select"
                    label="Pais de residencia"
                    name="PaisDeResidParaEfecFisc"
                    placeholder=""
                    help=""
                    rules={
                      rules.NoBeneficiario
                        .PaisDeResidParaEfecFisc
                    }
                    options={PaisesOptions}
                    value={
                      NoBeneficiario.PaisDeResidParaEfecFisc
                    }
                    onChange={handleOnNoBeneficiarioChange}
                  />
                </Col>
                <Col sm md={3}>
                  <FormControl
                    type="select"
                    label="Concepto Pago"
                    name="ConceptoPago"
                    placeholder=""
                    help=""
                    rules={rules.NoBeneficiario.ConceptoPago}
                    options={ConceptoPagoOptions}
                    value={NoBeneficiario.ConceptoPago}
                    onChange={handleOnNoBeneficiarioChange}
                  />
                </Col>
                <Col sm md={12}>
                  <FormControl
                    as="textarea"
                    label="Descripción Concepto"
                    name="DescripcionConcepto"
                    placeholder=""
                    help=""
                    minLength="1"
                    maxLength="256"
                    rules={
                      rules.NoBeneficiario.DescripcionConcepto
                    }
                    value={NoBeneficiario.DescripcionConcepto}
                    onChange={handleOnNoBeneficiarioChange}
                  />
                </Col>
              </Row>
            </>
          )}

          <Row>
            <Col>
              <Button
                variant="secondary"
                className="mr-2"
                onClick={handleOutForm}
              >
                Cancelar
              </Button>

              <Button
                variant="primary"
                disabled={!isValid}
                onClick={handleOnComplementoAdd}
              >
                Agregar complemento
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default ComplementoPagosaextranjeros;
